
import { useState } from 'react';
import Layout from '../../../../components/layout/Layout';

interface Premio {
  id: number;
  nome: string;
  tipo: string;
  valor: string;
  posicao: string;
  descricao: string;
}

export default function PremiacaoPage() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [premios, setPremios] = useState<Premio[]>([
    {
      id: 1,
      nome: 'Prêmio Ouro',
      tipo: 'dinheiro',
      valor: '5000',
      posicao: '1º Lugar',
      descricao: 'Bônus em dinheiro para o primeiro colocado'
    },
    {
      id: 2,
      nome: 'Prêmio Prata',
      tipo: 'dinheiro',
      valor: '3000',
      posicao: '2º Lugar',
      descricao: 'Bônus em dinheiro para o segundo colocado'
    },
    {
      id: 3,
      nome: 'Prêmio Bronze',
      tipo: 'pontos',
      valor: '2000',
      posicao: '3º Lugar',
      descricao: 'Pontos extras para o terceiro colocado'
    }
  ]);

  const [novoPremio, setNovoPremio] = useState({
    nome: '',
    tipo: '',
    valor: '',
    posicao: '',
    descricao: ''
  });

  const handleAddPremio = () => {
    if (novoPremio.nome && novoPremio.tipo && novoPremio.valor) {
      setPremios([...premios, { ...novoPremio, id: Date.now() }]);
      setNovoPremio({ nome: '', tipo: '', valor: '', posicao: '', descricao: '' });
      setShowAddModal(false);
    }
  };

  const handleRemovePremio = (id: number) => {
    setPremios(premios.filter(premio => premio.id !== id));
  };

  const getTipoIcon = (tipo: string) => {
    const icons = {
      'dinheiro': 'ri-money-dollar-circle-line',
      'pontos': 'ri-coin-line',
      'produto': 'ri-gift-line',
      'viagem': 'ri-flight-takeoff-line',
      'experiencia': 'ri-star-line'
    };
    return icons[tipo as keyof typeof icons] || 'ri-gift-line';
  };

  const getTipoColor = (tipo: string) => {
    const colors = {
      'dinheiro': 'bg-emerald-100 text-emerald-800',
      'pontos': 'bg-orange-100 text-orange-800',
      'produto': 'bg-blue-100 text-blue-800',
      'viagem': 'bg-purple-100 text-purple-800',
      'experiencia': 'bg-pink-100 text-pink-800'
    };
    return colors[tipo as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getTipoLabel = (tipo: string) => {
    const labels = {
      'dinheiro': 'Dinheiro',
      'pontos': 'Pontos',
      'produto': 'Produto',
      'viagem': 'Viagem',
      'experiencia': 'Experiência'
    };
    return labels[tipo as keyof typeof labels] || tipo;
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Premiação</h1>
            <p className="text-gray-600 mt-1">Configure os prêmios e recompensas da campanha</p>
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-add-line"></i>
            </div>
            <span>Adicionar Prêmio</span>
          </button>
        </div>

        {/* Progress Steps */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Dados Básicos</span>
            </div>
            <div className="flex-1 h-1 bg-emerald-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Objetivos</span>
            </div>
            <div className="flex-1 h-1 bg-emerald-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Ações</span>
            </div>
            <div className="flex-1 h-1 bg-emerald-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Regras</span>
            </div>
            <div className="flex-1 h-1 bg-blue-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold">
                5
              </div>
              <span className="font-semibold text-gray-900">Premiação</span>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total de Prêmios</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{premios.length}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-gift-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Valor Total</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">
                  R$ {premios.filter(p => p.tipo === 'dinheiro').reduce((sum, p) => sum + Number(p.valor), 0).toLocaleString('pt-BR')}
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-emerald-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-money-dollar-circle-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pontos Totais</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">
                  {premios.filter(p => p.tipo === 'pontos').reduce((sum, p) => sum + Number(p.valor), 0).toLocaleString('pt-BR')}
                </p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-orange-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-coin-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Premios List */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Prêmios Configurados</h3>
          
          {premios.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-gift-line text-gray-400 text-2xl"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhum prêmio configurado</h3>
              <p className="text-gray-600 mb-4">Adicione prêmios para motivar os participantes</p>
              <button
                onClick={() => setShowAddModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Adicionar Primeiro Prêmio
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {premios.map((premio) => (
                <div key={premio.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center space-x-3">
                      <div className={`w-12 h-12 rounded-lg ${getTipoColor(premio.tipo)} flex items-center justify-center`}>
                        <div className="w-6 h-6 flex items-center justify-center">
                          <i className={`${getTipoIcon(premio.tipo)} text-xl`}></i>
                        </div>
                      </div>
                      <div>
                        <h4 className="text-base font-semibold text-gray-900">{premio.nome}</h4>
                        <span className="text-xs text-gray-600">{premio.posicao}</span>
                      </div>
                    </div>
                    <button
                      onClick={() => handleRemovePremio(premio.id)}
                      className="text-red-600 hover:text-red-800 cursor-pointer"
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-delete-bin-line"></i>
                      </div>
                    </button>
                  </div>
                  
                  <p className="text-sm text-gray-600 mb-3">{premio.descricao}</p>
                  
                  <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTipoColor(premio.tipo)}`}>
                      {getTipoLabel(premio.tipo)}
                    </span>
                    <span className="text-lg font-bold text-gray-900">
                      {premio.tipo === 'dinheiro' ? `R$ ${Number(premio.valor).toLocaleString('pt-BR')}` : `${premio.valor} pts`}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Add Premio Modal */}
        {showAddModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900">Adicionar Prêmio</h3>
                <button
                  onClick={() => setShowAddModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome do Prêmio</label>
                  <input
                    type="text"
                    value={novoPremio.nome}
                    onChange={(e) => setNovoPremio({ ...novoPremio, nome: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Ex: Prêmio Ouro"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Prêmio</label>
                  <select
                    value={novoPremio.tipo}
                    onChange={(e) => setNovoPremio({ ...novoPremio, tipo: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
                  >
                    <option value="">Selecione o tipo</option>
                    <option value="dinheiro">Dinheiro</option>
                    <option value="pontos">Pontos</option>
                    <option value="produto">Produto</option>
                    <option value="viagem">Viagem</option>
                    <option value="experiencia">Experiência</option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Valor</label>
                    <input
                      type="number"
                      value={novoPremio.valor}
                      onChange={(e) => setNovoPremio({ ...novoPremio, valor: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      placeholder="0"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Posição</label>
                    <input
                      type="text"
                      value={novoPremio.posicao}
                      onChange={(e) => setNovoPremio({ ...novoPremio, posicao: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      placeholder="Ex: 1º Lugar"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Descrição</label>
                  <textarea
                    value={novoPremio.descricao}
                    onChange={(e) => setNovoPremio({ ...novoPremio, descricao: e.target.value })}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Descreva o prêmio..."
                  ></textarea>
                </div>

                <div className="flex items-center justify-end space-x-3 pt-4">
                  <button
                    onClick={() => setShowAddModal(false)}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleAddPremio}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Adicionar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Success Box */}
        <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <div className="w-5 h-5 flex items-center justify-center mt-0.5">
              <i className="ri-checkbox-circle-line text-emerald-600"></i>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-emerald-900 mb-1">Campanha Pronta!</h4>
              <p className="text-sm text-emerald-800">
                Você concluiu todas as etapas de configuração da campanha. Revise as informações e ative a campanha quando estiver pronto.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-between">
          <button className="px-6 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
            <span>Voltar: Regras</span>
          </button>
          <div className="flex items-center space-x-3">
            <button className="px-6 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
              Salvar Rascunho
            </button>
            <button className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-check-line"></i>
              </div>
              <span>Ativar Campanha</span>
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
